import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import { SwitcherComponent } from "./switcher/switcher";


@NgModule({
	imports: [
		CommonModule,
	],
	declarations: [
		SwitcherComponent,
	],
	providers: [],
	exports: [
		SwitcherComponent
	],
	entryComponents: [
		SwitcherComponent,
	]
})
export class UIModule {
	
}
